module.exports = __webpack_public_path__ + "img/star.2c8f0157.png";